// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfw_a bha_un bha_cw bha_a","MenuItem__Btn":"bfw_b bha_z"};